import { render, staticRenderFns } from "./ProviderProductSelector.vue?vue&type=template&id=0db5fb66"
import script from "./ProviderProductSelector.vue?vue&type=script&lang=js"
export * from "./ProviderProductSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports